import { ReactComponent as AlpineResorts } from 'public/assets/resort/partner_alpineresorts.svg';
import { SubscriberDataEvent } from '@/tracking/analytics';

export const patnerTypes = {
  lessons: {
    icon: <img src="/assets/resort/partner_skiBro.png" alt="Ski Bro" height={143} />,
    header: 'tripWidget.schoolBooking',
    analiticType: SubscriberDataEvent.LessonsWidget,
    benefits: ['tripWidget.checkYetiBenefits1', 'tripWidget.checkYetiBenefits2', 'tripWidget.checkYetiBenefits3'],
  },
  rental: {
    icon: <AlpineResorts height={143} width={143} />,
    header: 'tripWidget.skiRentalLabel',
    analiticType: SubscriberDataEvent.RentalsWidget,
    benefits: ['tripWidget.skiRentalBenefits1', 'tripWidget.skiRentalBenefits2', 'tripWidget.skiRentalBenefits3'],
  },
};
